document.addEventListener('DOMContentLoaded', function() {
  // Active nav link based on current URL
  var links = document.querySelectorAll('.nl a');
  links.forEach(function(a) {
    if (a.getAttribute('href') === window.location.pathname) {
      a.classList.add('act');
    }
  });
});
